/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import KeyboardExtraBarButton from './KeyboardExtraBarButton';
/* Labels */
const RANGE_LABEL = 'rangeNumberKeyboard.range.button.label';
const RATIO_LABEL = 'rangeNumberKeyboard.ratio.button.label';
const LESS_THAN_LABEL = 'rangeNumberKeyboard.less-than.button.label';
const GREATER_THAN_LABEL = 'rangeNumberKeyboard.greater-than.button.label';
const DONE_LABEL = 'rangeNumberKeyboard.done.button.label';

const KeyboardExtraBarValue = props => (
  <div className={'keb-container'}>
    <KeyboardExtraBarButton
      label={RANGE_LABEL}
      onClick={props.onKeyPress}
    />
    <KeyboardExtraBarButton
      label={RATIO_LABEL}
      onClick={props.onKeyPress}
    />
    <KeyboardExtraBarButton
      label={LESS_THAN_LABEL}
      onClick={props.onKeyPress}
    />
    <KeyboardExtraBarButton
      label={GREATER_THAN_LABEL}
      onClick={props.onKeyPress}
    />
    <KeyboardExtraBarButton
      label={DONE_LABEL}
      onClick={props.onSubmitPress}
    />
  </div>
);

KeyboardExtraBarValue.propTypes = {
  onKeyPress: PropTypes.func,
  onSubmitPress: PropTypes.func,
};

export default KeyboardExtraBarValue;
